import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-block"
}
const _hoisted_2 = {
  key: 1,
  class: "properties-group"
}
const _hoisted_3 = { class: "properties-group__header" }
const _hoisted_4 = { class: "properties-group__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioSelect = _resolveComponent("PortfolioSelect")!
  const _component_property_card = _resolveComponent("property-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_ctx.properties.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.blocksVisibility['discover-you-new-home'])
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-center mb-6 pb-6" }, " Discover your new home ", -1)),
              (_ctx.blocksVisibility['discover-you-new-home'])
                ? (_openBlock(), _createBlock(_component_PortfolioSelect, {
                    key: 0,
                    modelValue: _ctx.selectedPortfolioId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPortfolioId) = $event)),
                    portfolios: _ctx.portfolios
                  }, null, 8, ["modelValue", "portfolios"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.propertiesGroup && _ctx.blocksVisibility['featured-locations'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.propertiesGroup.name) + " Locations ", 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_row, { wrap: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentGroupItems, (property) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: property.id,
                        cols: "12",
                        sm: _ctx.currentGroupItems.length < 3 ? 6 : 4
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_property_card, { property: property }, null, 8, ["property"])
                        ]),
                        _: 2
                      }, 1032, ["sm"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}